module.exports = __webpack_public_path__ + "static/media/footer.c0d2f29a.png";